import '../../js/lib/jquery.min'
import './src/preload'
import './src/socials'
require(['../../js/lib/skrollr.min.js'], function (skrollr) {
  skrollr.init({
    constants: {
      // fill the box for a "duration" of 150% of the viewport (pause for 150%)
      // adjust for shorter/longer pause
      box: '150p'
    }
  })
}
)

console.log("It's working: shared!")
